<div class="mb-27 mct-flex-lt-md mct-col-lt-md mct-flex-gt-md mct-row-gt-md mct-gap-20"   >
  <div class="mct-flex mct-col mct-basis-34"  >
    <label class="light-text">{{ 'web-content.edit.title-label' | translate | titlecase }}</label>
    <input
      type="text"
      class="form-control"
      placeholder="{{ 'web-content.search-params.title' | translate | titlecase }}"
      [(ngModel)]="webContentRecord.ContentTitle"
      data-cy="inputWebContentTitle"
      [disabled]="isReadOnly"
    />
  </div>
  <div class="mct-flex mct-col mct-basis-33"  >
    <label class="light-text">{{ 'web-content.edit.format' | translate | titlecase }}</label>
    <p-select
      placeholder="{{ 'web-content.search-params.select-label' | translate }}"
      appendTo="body"
      [(ngModel)]="webContentRecord.ContentFormat"
      [options]="webContentFormats"
      [style]="{ width: '100%', height: '36px' }"
      data-cy="selectWebContentFormat"
      [disabled]="isReadOnly"
    ></p-select>
  </div>
  <div class="mct-flex mct-col mct-basis-33"  >
    <label class="light-text">{{ 'web-content.edit.content-type' | translate | titlecase }}</label>
    <p-select
      placeholder="{{ 'web-content.search-params.select-label' | translate }}"
      appendTo="body"
      [(ngModel)]="webContentRecord.ContentTypeID"
      [options]="webContentTypes"
      [style]="{ width: '100%', height: '36px' }"
      data-cy="selectWebContentType"
      [disabled]="isReadOnly"
      optionLabel="ContentType"
      optionValue="ContentTypeID"
    ></p-select>
  </div>
</div>
<ng-container *ngIf="webContentRecord.ContentFormat">
  <div class="mb-27">
    <div
      *ngIf="
        webContentRecord.ContentFormat === webContentFormatEnum.Document ||
        webContentRecord.ContentFormat === webContentFormatEnum.Image ||
        webContentRecord.ContentFormat === webContentFormatEnum.Report
      "
    >
      <input #uploader type="file" [disabled]="isReadOnly" hidden (change)="fileSelected($event)" data-cy="inputWebContentUploadFile" />
      <button pButton type="button" class="atlas-btn atlas-btn-primary mr-10" [disabled]="isReadOnly" (click)="uploader.click()">
        <span *ngIf="!webContentRecord.ContentID">{{ 'web-content.edit.upload-a-file' | translate | uppercase }}</span>
        <span *ngIf="webContentRecord.ContentID">{{ 'web-content.edit.change-file' | translate | uppercase }}</span>
      </button>
      <span class="f-si" *ngIf="fileToUpload">{{ fileToUpload.name }}</span>
    </div>
    <div *ngIf="webContentRecord.ContentFormat === webContentFormatEnum.Html">
      <form #test="ngForm">
        <wl-wysiwyg-editor
          name="html"
          [showHtmlTemplates]="false"
          [isReadOnly]="isReadOnly"
          [disableImageSelector]="true"
          [(ngModel)]="webContentRecord.HTML"
        ></wl-wysiwyg-editor>
      </form>
    </div>
    <div *ngIf="webContentRecord.ContentFormat === webContentFormatEnum.Export">
      <label class="light-text"
        >{{ 'web-content.edit.export-sql' | translate }}
        <textarea cols="120" [disabled]="isReadOnly" pInputTextarea [(ngModel)]="webContentRecord.SQL"></textarea>
      </label>
    </div>
  </div>
</ng-container>
<a *ngIf="!showAccessTextArea; else accessTextArea" (click)="showAccessTextArea = true">
  {{ 'web-content.edit.control-access-text' | translate | ucfirst }}
</a>
<ng-template #accessTextArea>
  <div class="mb-27">
    <p-checkbox
      binary="true"
      [(ngModel)]="webContentRecord.RestrictForMembersOnly"
      [disabled]="isReadOnly"
      inputId="restrictForMembersOnly"
    >
    </p-checkbox>
    <label for="restrictForMembersOnly">
      {{ 'web-content.edit.only-members-checkbox' | translate | ucfirst }}
    </label>
  </div>
  <label class="light-text">{{ 'web-content.edit.restrictions-based-on-aff-codes' | translate | ucfirst }}</label>
  <p-autocomplete
    #autoComplete
    appendTo="body"
    optionLabel="AffCode"
    [(ngModel)]="selectedAffCodes"
    [disabled]="isReadOnly"
    [multiple]="true"
    [suggestions]="affCodeSearchResults"
    (completeMethod)="searchAffCodes($event)"
    (onSelect)="addAffCode($event)"
    (onUnselect)="deleteAffCode($event)"
  >
  </p-autocomplete>
  <span class="mt-6 light-text">{{ 'web-content.edit.aff-code-help-text' | translate | ucfirst }}</span>
</ng-template>
<div>
  <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="save()" [disabled]="isSaving" data-cy="btnNewWebContent">
    {{ 'ecommerce.item.downloadable-web-content.save-web-contnet' | translate | uppercase }}
  </button>
</div>
